import React from 'react';
import { useDrag } from 'react-dnd';

function DocumentHPI() {
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'hpi' },
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  });

  return <div ref={drag}
    style={{
      cursor: 'move',
      opacity: isDragging ? 0.1 : 1
    }} className="card mb-2">
    <div className="card-body p-2 bg-white">
      HPI
    </div>
  </div>
}

export default DocumentHPI;